"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Our cloud flare account in Prod has  image caching. So we always use prod for caching images.
const cloudFlareImageRenderUrl = 'https://www.rafflebox.ca/cdn-cgi/image';
/**
 * Renders an image by appending Cloud Flare's image rendering service.
 * @param config
 * @returns
 */
exports.renderImage = (config) => {
    return (imageUrl, formatOptions) => {
        let url = `${cloudFlareImageRenderUrl}/quality=100`;
        if (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.height) {
            url += `,height=${formatOptions.height}`;
        }
        if (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.width) {
            url += `,width=${formatOptions.width}`;
        }
        let originImageUrl = imageUrl;
        if (!imageUrl.startsWith('https://')) {
            // if relative url then assume we are fetching from
            originImageUrl = `${config.raffleboxImagesUrl}/${imageUrl}`;
        }
        url += `/${originImageUrl}`;
        return url;
    };
};
exports.default = exports.renderImage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVuZGVyLWltYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3JlbmRlci1pbWFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVNBLGdHQUFnRztBQUNoRyxNQUFNLHdCQUF3QixHQUFHLHdDQUF3QyxDQUFDO0FBRTFFOzs7O0dBSUc7QUFDVSxRQUFBLFdBQVcsR0FBRyxDQUFDLE1BQXlCLEVBQVksRUFBRTtJQUNqRSxPQUFPLENBQUMsUUFBZ0IsRUFBRSxhQUFrQyxFQUFVLEVBQUU7UUFDdEUsSUFBSSxHQUFHLEdBQUcsR0FBRyx3QkFBd0IsY0FBYyxDQUFDO1FBRXBELElBQUksYUFBYSxhQUFiLGFBQWEsdUJBQWIsYUFBYSxDQUFFLE1BQU0sRUFBRTtZQUN6QixHQUFHLElBQUksV0FBVyxhQUFhLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDMUM7UUFFRCxJQUFJLGFBQWEsYUFBYixhQUFhLHVCQUFiLGFBQWEsQ0FBRSxLQUFLLEVBQUU7WUFDeEIsR0FBRyxJQUFJLFVBQVUsYUFBYSxDQUFDLEtBQUssRUFBRSxDQUFDO1NBQ3hDO1FBRUQsSUFBSSxjQUFjLEdBQUcsUUFBUSxDQUFDO1FBRTlCLElBQUksQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLFVBQVUsQ0FBQyxFQUFFO1lBQ3BDLG1EQUFtRDtZQUNuRCxjQUFjLEdBQUcsR0FBRyxNQUFNLENBQUMsa0JBQWtCLElBQUksUUFBUSxFQUFFLENBQUM7U0FDN0Q7UUFFRCxHQUFHLElBQUksSUFBSSxjQUFjLEVBQUUsQ0FBQztRQUU1QixPQUFPLEdBQUcsQ0FBQztJQUNiLENBQUMsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGtCQUFlLG1CQUFXLENBQUMifQ==